import { computed } from "#imports";
import { COMPONENT_VISIBILITY_TYPES } from "~/utils/constants.js";
import { useAccountClient } from "~/composables/useAccountClient";
import { useAuthStorage } from "~/composables/useAuthStorage";

export function useUser() {
  const { user, userReady } = useAccountClient();
  const { getProfilePicture, profilePicture: storedProfilePicture } =
    useAuthStorage();

  // Trigger initialization once on client
  if (import.meta.client) {
    getProfilePicture();
  }

  const isLogged = computed(() => !!user.value?.email);
  const fullName = computed(() => {
    if (!user.value) return "";
    const result = [];
    if (user.value.firstname) result.push(user.value.firstname);
    if (user.value.lastname) result.push(user.value.lastname);
    return result.join(" ");
  });

  const profilePicture = computed(() => {
    if (user.value?.profile_picture) return user.value.profile_picture;
    return storedProfilePicture.value;
  });

  const isValidLoyaltyProgram = computed(() => {
    return user?.value?.loyalty_program?.card?.is_valid;
  });

  const showComponentByState = (state) => {
    if (state === COMPONENT_VISIBILITY_TYPES.all) return true;

    if (
      state === COMPONENT_VISIBILITY_TYPES.membersCsc &&
      isValidLoyaltyProgram.value
    )
      return true;

    if (
      state === COMPONENT_VISIBILITY_TYPES.logged &&
      isLogged.value &&
      !isValidLoyaltyProgram.value
    )
      return true;

    return state === COMPONENT_VISIBILITY_TYPES.unLogged && !isLogged.value;
  };

  return {
    user,
    userReady,
    isLogged,
    isCscMember: isValidLoyaltyProgram,
    fullName,
    profilePicture: profilePicture,
    showComponentByState,
  };
}
